import React from 'react';
import { Home } from '../components/ecosystems';
import Layout from '../components/layout';
import {Helmet} from "react-helmet";

const HomePage = () => (
  <Layout>
      <Helmet>
          <title>Funny Videos - America's Funniest Home Videos</title>
          <meta name="description" content="Watch the official American Funny videos at one and only AFV (American Funny Videos). Watch a variety of funniest home videos , animals, pets, kids videos etc." />

      </Helmet>
    <Home />
  </Layout>
);

export default HomePage;
